export const Blood1Icon = () => {
    return <div>🩸</div>;
};
